import * as React from "react";
import { MapPin, Sparkles } from "lucide-react";
import { Badge } from "@/components/ui/badge";
const localSecrets = [{
  id: 1,
  title: "Las Olas Boulevard",
  category: "Dining",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/las_olas_neon_dining.png",
  tip: "Skip the main strip and head to the side streets for authentic local flavors. The seafood here is caught fresh daily and served with a neon-lit ambiance.",
  heightClass: "h-[400px]"
}, {
  id: 2,
  title: "Hugh Taylor Birch State Park",
  category: "Hidden Gems",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/birch_park_sunset.png",
  tip: "Rent a kayak and explore the coastal dune lakes at dusk. It's a quiet, immersive escape just steps from the high-energy beach.",
  heightClass: "h-[300px]"
}, {
  id: 3,
  title: "Riverwalk Fort Lauderdale",
  category: "Sightseeing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/riverwalk_night_lights.png",
  tip: "Take the water taxi at sunset for the best views of the city skyline. The neon reflections on the water create a perfect noir atmosphere.",
  heightClass: "h-[450px]"
}, {
  id: 4,
  title: "Elbo Room Historic Balcony",
  category: "Hidden Gems",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/elbo_room_balcony_view.png",
  tip: "Grab a spot on the second-floor balcony early in the evening. It's the ultimate vantage point for people-watching as the strip comes alive.",
  heightClass: "h-[350px]"
}, {
  id: 5,
  title: "Bonnet House Museum",
  category: "Sightseeing",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/bonnet_house_tropical.png",
  tip: "Look out for the wild monkeys roaming the estate grounds. The art and architecture blend perfectly with the lush, saturated tropical setting.",
  heightClass: "h-[400px]"
}, {
  id: 6,
  title: "15th Street Fisheries",
  category: "Dining",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587258/img/fisheries_marina_glow.png",
  tip: "Feed the massive tarpon right off the dock while you wait for your table. The waterfront dining experience is a high-octane local staple.",
  heightClass: "h-[320px]"
}];
export default function FortLauderdaleEssentials() {
  return <section id="fort-lauderdale-essentials" className="dark bg-background text-foreground py-24 px-4 md:px-8 lg:px-12 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-full pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="flex flex-col items-center text-center mb-16">
          <Badge variant="outline" className="mb-4 border-primary/50 text-primary bg-primary/10 backdrop-blur-sm px-4 py-1">
            <Sparkles className="w-4 h-4 mr-2" />
            City Guide
          </Badge>
          <h2 className="text-4xl md:text-6xl font-serif uppercase tracking-wider text-foreground drop-shadow-[0_0_15px_rgba(245,158,11,0.3)] mb-6">
            Fort Lauderdale <span className="text-primary">Essentials</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl font-sans">
            Curated local secrets and high-energy hotspots. Discover the definitive guide to the city's dining, sightseeing, and hidden gems.
          </p>
        </div>

        {}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 space-y-6">
          {localSecrets.map((secret, i) => <div key={secret.id} data-index={i} className={`relative overflow-hidden rounded-xl group break-inside-avoid shadow-2xl border border-border/50 bg-card ${secret.heightClass}`}>
              {}
              <img src={secret.image} alt={secret.title} className="absolute inset-0 w-full h-full object-cover saturate-150 transition-transform duration-700 ease-out group-hover:scale-110" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-transparent to-background/90 pointer-events-none" />

              {}
              <div className="absolute top-4 left-4 z-20">
                <Badge variant="default" className="bg-primary text-primary-foreground font-bold uppercase tracking-wider shadow-[0_0_10px_rgba(245,158,11,0.5)]">
                  {secret.category}
                </Badge>
              </div>

              {}
              <div className="absolute bottom-6 left-6 right-6 z-10 transition-opacity duration-300 group-hover:opacity-0">
                <h3 className="text-2xl font-serif tracking-wide text-white drop-shadow-md flex items-center gap-2">
                  <MapPin className="w-5 h-5 text-primary" />
                  {secret.title}
                </h3>
              </div>

              {}
              <div className="absolute inset-x-0 bottom-0 p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-400 ease-in-out bg-background/95 backdrop-blur-md border-t border-primary/30 z-20 h-auto min-h-[50%] flex flex-col justify-center">
                <h3 className="text-2xl font-serif tracking-wide text-foreground mb-3 uppercase">
                  {secret.title}
                </h3>
                <div className="flex items-start gap-3">
                  <span className="text-primary text-2xl leading-none mt-1 drop-shadow-[0_0_5px_rgba(245,158,11,0.8)]">
                    •
                  </span>
                  <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                    {secret.tip}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}